module.exports = __webpack_public_path__ + "img/border_bottom.471e6a7c.png";